// import courseInstanceReducer from './courseInstanceReducer';
import folderReducer from "./folderReducer"
import clipboardReducer from "./clipboardReducer";

export default {
    folderReducer,
    clipboardReducer
    // courseInstanceReducer
}
